import React from 'react';
import Pagination from './Pagination';
import './CaseStudiesPanel.css';

const CaseStudiesPanel = ({
  caseStudies,
  caseStudiesLoading,
  filteredCaseStudies,
  paginatedCaseStudies,
  currentPage,
  setCurrentPage,
  totalPages,
  startIndex,
  endIndex,
  searchQuery,
  proofT,
  isAuthenticated = false
}) => {
  return (
    <div className="tab-panel active">
      <div className="case-studies-grid">
        {caseStudiesLoading ? (
          <div className="loading-message">{proofT('caseStudies.loading')}</div>
        ) : paginatedCaseStudies.length === 0 ? (
          <div className="no-results">{proofT('caseStudies.noResults')}</div>
        ) : (
          <>
            {/* Results count - only show when there are results */}
            <div className="results-info">
              <p className="results-text">
                {proofT('caseStudies.showing', 'Showing {start}-{end} of {total} case studies')
                  .replace('{start}', startIndex + 1)
                  .replace('{end}', Math.min(endIndex, filteredCaseStudies.length))
                  .replace('{total}', filteredCaseStudies.length)}
                {searchQuery && proofT('caseStudies.forQuery', ' for "{query}"').replace('{query}', searchQuery)}
              </p>
            </div>
            {paginatedCaseStudies.map((study) => (
              <div key={study.id} className="case-study" data-industry={study.industry}>
                <div className="case-study-header">
                  <div className="case-study-logo">
                    <img 
                      src={`/icons/case_studies/${study.id}.png`} 
                      alt={`${study.company || ''} ${proofT('caseStudies.logoAlt')}`} 
                      className="case-study-logo-img"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        // Create a fallback div with company initials
                        const fallback = document.createElement('div');
                        fallback.className = 'case-study-logo-fallback';
                        fallback.textContent = (study.company || '??').substring(0, 2).toUpperCase();
                        e.target.parentNode.appendChild(fallback);
                      }}
                    />
                  </div>
                  <div className="company-info">
                    <div className="company-name">{study.company || ''}</div>
                    <div className="company-industry">{study.industry || ''}</div>
                  </div>
                  {isAuthenticated && study.roi && <div className="impact-badge">{study.roi}{proofT('caseStudies.roi')}</div>}
                </div>
                <div className="case-study-content">
                  {study.description || ''}
                </div>
                <div className="case-study-footer">
                  <div className="website-options">
                    {study.website && (
                      <a 
                        href={study.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="website-btn"
                        title={proofT('caseStudies.visitWebsiteTitle', 'Visit {company} website').replace('{company}', study.company || '')}
                      >
                        {proofT('caseStudies.visitWebsite')}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
      
      {/* Pagination Controls */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        proofT={proofT}
      />
    </div>
  );
};

export default CaseStudiesPanel;

